<template>
  <div class="notifications">
    <transition-group name="transition" tag="div">
      <notification
        v-for="notification in notificationList"
        :key="notification.id"
        v-bind="notification"
      />
    </transition-group>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import { mapGetters } from "vuex";
import { getters } from "@/store";
export default {
  computed: {
    ...mapGetters([getters.notificationList])
  },
  components: { Notification }
};
</script>

<style scoped lang="scss">
.notifications {
  position: fixed;
  top: 0;
  right: 0;
}
.transition {
  &-enter-active,
  &-leave-active {
    transition-duration: 0.5s;
    transition-property: transform, opacity;
  }
  &-enter-to,
  &-leave {
    opacity: 1;
    transform: translateX(0%);
  }
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateX(100%);
  }
}
</style>
